<template>
  <Dialog
    title="Eleven er tilmeldt prøvetilmeldinger efter den valgte slutdato"
    :loading="loading"
    data-testid="confirm-exam-registration-deregistration-dialog"
    @close="handleClose"
  >
    <template #buttons>
      <BaseButton size="lg" :disabled="loading" data-testid="keepExamRegistrations" @click="$emit('close', 'keep')"> Behold prøvetilmeldinger </BaseButton>
      <BaseButton primary size="lg" :loading="loading" data-testid="deregisterExamRegistrations" @click="$emit('close', 'deregister')">
        Afmeld prøvetilmeldinger
      </BaseButton>
    </template>
  </Dialog>
</template>

<script>
import Dialog from "~/components/dialogs/Dialog";

export default {
  components: { Dialog },

  props: {
    loading: Boolean,
  },

  emits: ["close"],

  methods: {
    handleClose(value) {
      // The base Dialog emits `false` on Escape (and `true` on Cmd+Enter). Only
      // the two explicit buttons are real choices; anything else is a dismissal
      // and must cancel so the termination is NOT created.
      this.$emit("close", value === "keep" || value === "deregister" ? value : "cancel");
    },
  },
};
</script>
